import { getCookie } from "@/helpers/cookies";

const API_TOKEN = getCookie('PORTAL_TOKEN');

export default API_TOKEN;